import store from "../store/store";
import {
  verifyLineAccessToken,
} from "@/services/lineApi.service";

const homePageAuthGuard = async (to, from, next) => {
  try {
    store.commit("basic/setErrorLogin", { state: false, message: "" });
    console.log("to", to);
    console.log("from", from);
    const accessToken = store.getters['line/accessToken']
    const lineLoginData = store.state.line.lineLoginData;

//    // Modify By Bryant 2025041601 //
//    const queryString = window.location.search;
//    const urlParams = new URLSearchParams(queryString);
//    const liff_state = urlParams.get('liff.state')
//    if (liff_state)
//    {
////      console.log("liff_state", liff_state);
////      window.location.replace(liff_state);
////      window.location.replace(decodeURI(liff_state));
//      window.location.replace(liff_state);
////      window.location.href=liff_state;
//    }
//    // Modify By Bryant 2025041601 End //

    if (accessToken) {
      console.log("contains access token");
      if (!await verifyLineAccessToken(accessToken)) {
        console.log("line access token expires");
        store.commit("line/setLineLoginData", {});
      }
    } else {
      console.log("no access token", lineLoginData);
      const code = new URLSearchParams(window.location.search).get("code");
      if (code) {
        await store.dispatch('line/getToken', code)
      } else {
        throw new Error("Authorization code not found.");
      }
    }
  } catch (error) {
    // 登入失敗彈窗
    console.error('login error', error)
  } finally {
    next();
  }
};

export default homePageAuthGuard;
